import { zergApi } from "@/service/zerg";

class DaysService {

    async getDays(params) {
        try {
            const data = await zergApi.get("/days/get-all-days", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async saveHomeworkDays(params) {
        try {
            const data = await zergApi.post("/days/save-homework-days", params);
            return data;
        } catch (error) {
            throw error;
        }
    }
    async getHomeworkDays(params) {
        try {
            const data = await zergApi.post("/days/get-homework-days", params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new DaysService();
